export class SalesItemType{
    
    /** The id of a SIT. */
    _id: string;

	/** The key. */
    sitKey :string ;
    
    /** The value. */
    name:string ;
	
}